import type { LocationQuery } from 'vue-router';
import { AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL } from '~/constants/campaign';

const CAMPAIGN_TYPES: string[] = [AUDIENCE_TYPE_MARKETING, AUDIENCE_TYPE_TRANSACTIONAL];
const TO_TYPES: string[] = ['everyone', 'contacts', 'segments', 'external-contact-lists'];

export interface QuickBlastRouteProps {
    defaultCampaignType?: string;
    defaultTo?: string;
    defaultExternalContactListIds: number[];
    defaultSnippetId?: number;
}

const pickAllowedValue = (value: unknown, allowed: string[]): string | undefined => {
    return typeof value === 'string' && allowed.includes(value) ? value : undefined;
};

const toPositiveInteger = (value: unknown): number | undefined => {
    if (typeof value !== 'string' || !/^\d+$/.test(value)) {
        return undefined;
    }

    const parsed = Number(value);

    return parsed > 0 ? parsed : undefined;
};

const toUniquePositiveIntegers = (value: unknown): number[] => {
    const values: unknown[] = Array.isArray(value) ? value : [value];
    const integers = values.map(toPositiveInteger).filter((id): id is number => id !== undefined);

    return [...new Set(integers)];
};

export const quickBlastRouteProps = (query: LocationQuery): QuickBlastRouteProps => ({
    defaultCampaignType: pickAllowedValue(query.type, CAMPAIGN_TYPES),
    defaultTo: pickAllowedValue(query.to, TO_TYPES),
    defaultExternalContactListIds: toUniquePositiveIntegers(query.external_contact_list_ids),
    defaultSnippetId: toPositiveInteger(query.snippet_id),
});
